<template>
  <div class="w12 a">
    <div class="clearfix" style="margin: 25px 0">
      <div class="icon fl" style="margin-right: 7px">
        <img src="@/assets/imgYQ/dqwz.png" alt="" />
      </div>
      <div class="fl">
        <span class="fs14 c3 klxs" @click="goto('/')">当前位置：网站首页 </span>
        <span class="fs14" style="color: #808080"
          >> 山东省学生信息素养提升实践活动
        </span>
      </div>
    </div>
    <main>
      <div
        class="tool"
        @click="btn(index)"
        v-for="(item, index) in list"
        :key="index"
      >
        <p class="c3 fw">{{ item.p1 }}</p>
        <p class="c6 fw" style="margin-top: 16px">{{ item.p2 }}</p>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          p1: "2025年山东省学生信息素养提升实践活动",
          p2: "（指南）",
        },
        {
          p1: "2025年山东省学生信息素养提升实践活动秩序册",
          p2: "（文华学校）",
        },
        {
          p1: "2025年山东省学生信息素养提升实践秩序册",
          p2: "（富华展览）",
        },
      ],
    };
  },
  methods: {
    btn(val) {
      if (val === 0) {
        window.open(
          "pdf/2025年山东省学生信息素养提升实践活动（指南）.pdf",
          "_blank"
        );
      } else if (val === 1) {
        window.open(
          "pdf/2025年山东省学生信息素养提升实践活动秩序册（文华学校）.pdf",
          "_blank"
        );
      } else if (val === 2) {
        window.open(
          "pdf/2025年山东省学生信息素养提升实践秩序册（富华展览）.pdf",
          "_blank"
        );
      }
    },
    goto(url) {
      this.$router.push({
        path: url,
      });
    },
  },
  created() {},
  mounted() {},
};
</script>

<style scoped lang="scss">
main {
  padding-top: 59px;
  .tool {
    margin: 0 auto 30px;
    padding: 48px 0;
    text-align: center;
    width: 869px;
    // height: 158px;
    background-color: #fff;
    box-shadow: 3px 4px 5px 0px rgba(0, 25, 51, 0.1);
    border-radius: 10px;

    p {
      font-size: 24px;
    }
    &:nth-last-child(1) {
      margin-bottom: 90px;
    }
    &:hover {
      position: relative;
      top: -3px;
      box-shadow: 7px 9px 5px 0px rgba(0, 25, 51, 0.1);
    }
  }
}
</style>